import React from 'react';
import PropTypes from 'prop-types';
import { paymentTypes } from '../assets/statementData';

const PaymentRadio = ({
  paymentValues, paymentOptions, changeBalance, selectedRadioValue,
}) => (
  <fieldset className="width-full flex flex-column flex-align-start" aria-describedby="">
    <legend style={{ display: 'none' }} />
    {paymentOptions[0]?.eligibleOptions?.filter((option) => option !== 'FIXED_AMOUNT').map((option) => {
      const matchedOption = paymentValues?.find((defaultOption) => defaultOption.name === option);
      const isDisabled = matchedOption?.amount === 0;
      return (
        <React.Fragment key={`${option}`}>
          <div
            className="width-full flex  margin-1-tb"
            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
          >
            <input
              type="radio"
              id={`radio-button-${option}`}
              name="option"
              value={option}
              checked={selectedRadioValue === option}
              onChange={changeBalance}
              disabled={isDisabled}
              style={{ marginRight: '1rem', transform: 'scale(1.5)' }}
            />
            <div className="flex width-full flex-column">
              <span className="body-3">
                {paymentTypes[Object.keys(paymentTypes).find((key) => key === option)]}
              </span>
              <span>
                {`$${Number(matchedOption?.amount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
              </span>
            </div>
          </div>
          <hr />
        </React.Fragment>
      );
    })}
    <label
      htmlFor="radio-button-4"
      className="width-full flex margin-1-tb"
      style={{ cursor: 'pointer', alignItems: 'center' }}
    >
      <input
        type="radio"
        id="radio-button-4"
        name="option"
        value="option-4"
        checked={selectedRadioValue === 'option-4'}
        onChange={changeBalance}
        style={{ marginRight: '1rem', verticalAlign: 'middle', transform: 'scale(1.5)' }}
      />
      <span className="body-3">Other Amount</span>
    </label>
  </fieldset>
);

PaymentRadio.propTypes = {
  paymentValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ).isRequired,
  paymentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      eligibleOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
  changeBalance: PropTypes.func.isRequired,
  selectedRadioValue: PropTypes.string.isRequired,
};

export default PaymentRadio;
